import styles from './MinimizeWindowIcon.module.scss'

const MinimizeWindowIcon = () => {
  return (
    <div className={styles.container}>
      <svg width="14px" height="1px" viewBox="0 0 14 1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
          <title>Icon/minimize window</title>
          <g id="Icon/minimize-window" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
              <line x1="0" y1="0.5" x2="14" y2="0.5" id="Path-7" stroke="#979797" strokeWidth="3"></line>
          </g>
      </svg>
    </div>
  );
}

export default MinimizeWindowIcon;

